import PropTypes from 'prop-types'

import { getAssetLink } from '../../helpers/get-asset-link'

const ImagesContainer = ({ images, onClick }) => {
  return (
    <div className="images-container" onClick={onClick}>
      {images.length === 1 ? (
        <div
          style={{
            backgroundImage: `url(${getAssetLink({ path: 'chitown-images/groups', file: images[0] })})`,
          }}
          className="one-image"
        />
      ) : images.length === 2 ? (
        <div className="two-sides-container">
          {images.map((image, i) => (
            <div
              className="one-image"
              key={`${image}_${i}`}
              style={{
                backgroundImage: `url(${getAssetLink({ path: 'chitown-images/groups', file: image })})`,
              }}
            />
          ))}
        </div>
      ) : images.length > 2 ? (
        <div className="two-sides-container">
          <div
            className="one-image"
            style={{
              backgroundImage: `url(${getAssetLink({ path: 'chitown-images/groups', file: images[0] })})`,
            }}
          />
          <div className="block-container">
            {images.slice(1, 3).map((image, i) => (
              <div
                className="one-image"
                key={`${image}_${i}`}
                style={{
                  backgroundImage: `url(${getAssetLink({ path: 'chitown-images/groups', file: image })})`,
                }}
              />
            ))}
          </div>
        </div>
      ) : null}
      {images.length > 3 ? (
        <div className="extra-images-tip">
          <span>+{images.length - 3} more</span>
        </div>
      ) : null}
    </div>
  )
}

ImagesContainer.propTypes = {
  images: PropTypes.array,
  onClick: PropTypes.func,
}

export default ImagesContainer
